import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/tariffs`
}

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listTariffs ({customerId, params}) {
        try {
            const response = await http.get(getPath(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, tariffId: number,  params: {}}} data
     * @returns {Promise<void>}
     */
    async listTariffNumbers ({customerId, tariffId, params}) {
        try {
            const path = getPath(customerId)
            const response = await http.get(
                `${path}/${tariffId}/numbers`,
                {params}
            )
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
